// If .minu-menuu-sticky exists then only minu-menuu will be sticky

export function hideHeaderNavAndLogo() {
    const headerStickyContainer = document.querySelector(
        ".header-sticky-container"
    );
    const headerNav = document.querySelector(".header-sites-nav");
    const headerLogoRow = document.querySelector(".header-logo-row");
    const stickyMenu = document.querySelector(".minu-menuu-sticky");
    const logo = document.querySelector(
        ".header-sticky-logo-resize .wp-block-site-logo"
    );
    const resizeClassElement = document.querySelector(
        ".header-sticky-logo-resize"
    );
    const stickyHeaderNoNav = document.querySelector(".sticky-header-no-nav");
    const header = document.querySelector("header");
    const menuColumn = document.querySelector(".looming .menu-column");

    if (stickyHeaderNoNav) {
        const headerNavHeight = headerNav.offsetHeight;
        stickyHeaderNoNav.style.top = `-${headerNavHeight}px`;
    }

    if (stickyHeaderNoNav && headerNav) {
        let lastScrollY = window.scrollY;
        const headerNavHeight = headerNav.offsetHeight;

        stickyHeaderNoNav.style.top = `0px`;

        window.addEventListener("scroll", () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > headerNavHeight) {
                header.classList.add("hide-nav");

                // stickyHeaderNoNav.style.top = `-${headerNavHeight}px`;
            } else {
                header.classList.remove("hide-nav");

                // stickyHeaderNoNav.style.top = "0px";
            }

            lastScrollY = currentScrollY;
        });
    }

    if (headerNav && headerLogoRow && stickyMenu) {
        const headerNavHeight = headerNav.offsetHeight;
        const headerLogoRowHeight = headerLogoRow.offsetHeight;

        stickyMenu.style.top = `-${headerNavHeight + headerLogoRowHeight}px`;
    }

    // Add functionality to resize the logo when scrolled a bit
    if (headerStickyContainer) {
        let isSmall = false;
        window.addEventListener("scroll", function () {
            if (window.scrollY > 100) {
                headerStickyContainer.classList.add("is-scrolled");
            } else {
                headerStickyContainer.classList.remove("is-scrolled");
            }

            if (resizeClassElement) {
                if (window.scrollY > 100 && !isSmall) {
                    logo.classList.add("small");
                    headerLogoRow.style.padding = "0";
                    isSmall = true;
                } else if (window.scrollY <= 100 && isSmall) {
                    logo.classList.remove("small");
                    logo.style.transition = "transform 0.3s ease-in-out";
                    setTimeout(() => {
                        headerLogoRow.style.padding = "1.2rem 0";
                    }, 0);
                    isSmall = false;
                }
            }
        });
    }

    function setupStickyHeader(page) {
        // Check if the page element exists on the page
        const rootElement = document.querySelector(page);
        if (!rootElement) {
            return;
        }

        let previousScrollY = 0;

        window.addEventListener("scroll", function () {
            const siteLogo = document.querySelector(
                `${page} .wp-block-site-logo`
            );
            const siteLogoaTag = document.querySelector(
                `${page} .wp-block-site-logo a`
            );
            const headerLogoRow = document.querySelector(
                `${page} .header-logo-row`
            );
            const ulemMenuuRow = document.querySelector(
                `${page} .ulemine-menuu-row`
            );
            const telliMenuu = document.querySelector(
                `${page} header #menu-telli_menuu`
            );
            const header = document.querySelector(`${page} header`);
            const separator = document.querySelector(
                `${page} .wp-site-blocks header hr.wp-block-separator`
            );
            const headerContainer = document.querySelector(
                `${page} .header-container`
            );

            // Ensure a consistent header height to prevent flickering
            if (header) {
                header.style.height = header.offsetHeight + "px";
            }

            let currentScrollY = window.scrollY;
            let scrollThreshold = page === ".looming" ? 100 : 254;

            if (currentScrollY > scrollThreshold) {
                if (
                    ulemMenuuRow &&
                    ulemMenuuRow.firstElementChild !== siteLogo
                ) {
                    ulemMenuuRow.insertBefore(
                        siteLogo,
                        ulemMenuuRow.firstElementChild
                    );
                }
                if (telliMenuu) {
                    telliMenuu.style.display = "none";
                }

                headerContainer.classList.add("scrolled-container");
                // headerLogoRow.style.paddingTop = "0";

                if (page === ".looming") {
                    siteLogoaTag.style.width = "100%";
                } else {
                    siteLogoaTag.style.width = "70%";
                }
                if (separator) {
                    separator.style.margin = "0";
                }
                if (headerLogoRow && page !== ".vikerkaar") {
                    headerLogoRow.style.paddingTop = "4rem";
                }
            } else if (currentScrollY < previousScrollY) {
                if (
                    headerLogoRow &&
                    headerLogoRow.firstElementChild !== siteLogo
                ) {
                    if (page === ".vikerkaar") {
                        headerLogoRow.insertBefore(
                            siteLogo,
                            headerLogoRow.firstElementChild
                        );
                    } else if (page === ".sirp") {
                        ulemMenuuRow.insertBefore(
                            siteLogo,
                            ulemMenuuRow.firstElementChild
                        );
                    }
                }

                if (telliMenuu) {
                    telliMenuu.style.display = "";
                }

                headerContainer.classList.remove("scrolled-container");
                siteLogoaTag.style.width = "100%";

                if (page === ".vikerkaar") {
                    headerLogoRow.style.paddingTop = "1rem";
                } else if (page === ".sirp") {
                    headerLogoRow.style.paddingTop = "0";
                }

                if (separator) {
                    separator.style.margin = "1.2rem";
                }
                headerContainer.style.paddingBottom = "0";
            }

            previousScrollY = currentScrollY;
        });
    }

    if (window.innerWidth >= 900) {
        setupStickyHeader(".vikerkaar");
        setupStickyHeader(".sirp");
        setupStickyHeader(".looming");
    }

    const advancedSearchWrapper = document.querySelector(
        ".advanced-search-wrapper"
    );

    function checkAdvancedSearchVisibility() {
        if (
            window.getComputedStyle(advancedSearchWrapper).display === "block"
        ) {
            header.classList.add("advanced-search-visible");
        } else {
            header.classList.remove("advanced-search-visible");
        }
    }

    checkAdvancedSearchVisibility();

    const observer = new MutationObserver(checkAdvancedSearchVisibility);
    observer.observe(advancedSearchWrapper, {
        attributes: true,
        attributeFilter: ["style"],
    });

}
